export class DropdownItemsService {
  constructor(StrategiesFactory, $translate, UserFactory, AngularTimezoneService, AngularAlcmeonContextService) {
    this.StrategiesFactory = StrategiesFactory;
    this.$translate = $translate;
    this.UserFactory = UserFactory;
    this.AngularTimezoneService = AngularTimezoneService;
    this.AngularAlcmeonContextService = AngularAlcmeonContextService;
  }

  buildTagItems(tagsGroups) {
    return tagsGroups.map(groupFromBackend => {
      const items = [];
      let item;
      for (let i = 0; i < groupFromBackend.tags_and_categories.length; i++) {
        const tagOrCategory = groupFromBackend.tags_and_categories[i];
        if (tagOrCategory.is_category) {
          item = _emptyItem(tagOrCategory.name);
          items.push(item);
        } else {
          if (i === 0) {
            // Let's add a no-label category so as not to make a special case if there is no category at all
            item = _emptyItem();
            items.push(item);
          }
          item.subitems.push({
            id: tagOrCategory.id,
            label: tagOrCategory.name,
          });
        }
      }
      return {
        id: groupFromBackend.id,
        label: groupFromBackend.name,
        items: items,
      };
    });
  }

  buildRoutingTagItemsWithSpecialAnyItem(tagsGroup) {
    const routingTagGroups = tagsGroup.filter(groupFromBackend => groupFromBackend.is_routing === 1);
    const result =
      routingTagGroups.length > 0 ? this.buildTagItems(routingTagGroups)[0].items.flatMap(i => i.subitems) : [];
    result.unshift({
      id: -1,
      label: this.$translate.instant('account/actions-triggers/condition/any-team'),
    });
    return result;
  }

  buildActionTypeItems() {
    const items = [
      { id: 19, name: 'acquire' },
      { id: 56, name: 'anonymize' },
      { id: 1, name: 'answer' },
      { id: 0, name: 'archive' },
      { id: 27, name: 'assign-to' },
      { id: 2, name: 'auto-archive' },
      { id: 51, name: 'bzc-conversation-close' },
      { id: 50, name: 'bzc-delete' },
      { id: 16, name: 'comment' },
      { id: 41, name: 'execute-answer' },
      { id: 42, name: 'extra-comment' },
      { id: 29, name: 'facebook-ban' },
      { id: 15, name: 'facebook-delete' },
      { id: 57, name: 'facebook-delete-self-answer' },
      { id: 13, name: 'facebook-hide' },
      { id: 11, name: 'facebook-like' },
      { id: 32, name: 'facebook-publish' },
      { id: 30, name: 'facebook-unban' },
      { id: 14, name: 'facebook-unhide' },
      { id: 12, name: 'facebook-unlike' },
      { id: 28, name: 'first-seen' },
      { id: 54, name: 'gmb-review-deleted' },
      { id: 18, name: 'help-answer' },
      { id: 17, name: 'help-request' },
      { id: 46, name: 'instagram2-delete-comment' },
      { id: 59, name: 'instagram2-delete-self-answer' },
      { id: 48, name: 'instagram2-disable-media-comment' },
      { id: 47, name: 'instagram2-enable-media-comment' },
      { id: 44, name: 'instagram2-hide' },
      { id: 45, name: 'instagram2-unhide' },
      { id: 25, name: 'instagram-block' },
      { id: 34, name: 'instagram-delete' },
      { id: 23, name: 'instagram-follow' },
      { id: 35, name: 'instagram-like' },
      { id: 26, name: 'instagram-unblock' },
      { id: 24, name: 'instagram-unfollow' },
      { id: 36, name: 'instagram-unlike' },
      { id: 43, name: 'modified' },
      { id: 37, name: 'on-hold' },
      { id: 20, name: 'release' },
      { id: 52, name: 'sms-notification-sent' },
      { id: 3, name: 'twitter-favorite' },
      { id: 21, name: 'steal' },
      { id: 33, name: 'tag' },
      { id: 39, name: 'tag-vip' },
      { id: 38, name: 'task-create' },
      { id: 55, name: 'trustpilot-find-reviewer' },
      { id: 9, name: 'twitter-block' },
      { id: 22, name: 'twitter-delete' },
      { id: 58, name: 'twitter-delete-self-answer' },
      { id: 7, name: 'twitter-follow' },
      { id: 31, name: 'twitter-publish' },
      { id: 5, name: 'twitter-retweet' },
      { id: 53, name: 'twitter-retweet-publication' },
      { id: 10, name: 'twitter-unblock' },
      { id: 4, name: 'twitter-unfavorite' },
      { id: 8, name: 'twitter-unfollow' },
      { id: 6, name: 'twitter-unretweet' },
      { id: 40, name: 'untag-vip' },
      { id: 49, name: 'whatsapp-delete' },
    ];
    return items.map(item => {
      // const translatedLabel = this.$translate.instant('action/type/dropdown/' + item.name);
      return {
        id: item.id,
        label: item.name,
        sortKey: item.name,
        iconClass: null,
      };
    });
  }

  buildSiteItems(sites, isColorIcons = false) {
    return (sites || [])
      .filter(s => !!s)
      .map(({ id, site_group_id, name, type, type_name }) => ({
        id,
        site_group_id,
        label: name,
        type,
        typeName: type_name,
        sortKey: `${name.toLowerCase()}${type}`,
        iconClass: isColorIcons ? `alc-site-icon-inline bg-img-${type_name}` : `task-icon task-icon-${type_name}`,
      }));
  }

  buildSiteGroupItems(groups) {
    return groups.map(group => ({
      isGroup: true,
      id: group.id,
      label: `[Group] ${group.name}`,
      type: group.type,
      typeName: group.type_name,
      sortKey: `${group.name.toLowerCase()}${group.type}`,
    }));
  }

  buildUserItems(company) {
    return company.users
      .filter(user => user.is_active && !user.is_bot)
      .map(user => ({
        id: user.id,
        label: user.realname,
      }))
      .sort((a, b) => (a.label || '').localeCompare(b.label || ''));
  }

  buildChannelItems(sites) {
    const items = [];
    for (let strategy of this.StrategiesFactory.getAll()) {
      if (sites.find(site => site.type === strategy.getType())) {
        const tasks = strategy.getAllTasksTypes();
        this.AngularAlcmeonContextService.addPublicRepliesTaskIfAllowed(strategy, tasks);
        items.push({
        id: strategy.getType(),
          label: this.$translate.instant('account_type/' + strategy.getTypeString()),
          subitems: tasks.map(taskType => ({
            id: taskType,
            label: this.$translate.instant('task/' + strategy.getTaskTypeString(taskType)),
          })),
        });
      }
    }
    return items;
  }

  buildWeekDays() {
    return ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'].map((key, index) => ({
      id: index,
      label: this.$translate.instant(key),
      sortKey: index,
    }));
  }

  buildBhNbh() {
    return ['bh', 'nbh'].map((key, index) => ({
      id: key,
      label: this.$translate.instant('priority-rules/edition/condition-types/' + key),
      sortKey: index,
    }));
  }

  buildBhOrWallClock() {
    return [
      {
        id: 'wall_clock',
        label: this.$translate.instant(
          'account/incoming-messages/condition/not_processed_after/exclude_non_working_hours/0'
        ),
        sortKey: 0,
      },
      {
        id: 'bh',
        label: this.$translate.instant(
          'account/incoming-messages/condition/not_processed_after/exclude_non_working_hours/1'
        ),
        sortKey: 1,
      },
    ];
  }

  buildScenariosItems(scenarios) {
    return scenarios.map(scenario => ({
      id: scenario.id,
      label: scenario.name,
      scores: scenario.scores,
    }));
  }

  buildScoresItems(scenarios) {
    let items = [];
    scenarios.forEach(scenario => {
      items = items.concat(scenario.scenario_verbatim_details);
    });
    return items;
  }

  buildOptinItems(optins) {
    return optins.map(({ id, name }) => ({ id, label: name }));
  }

  buildTimezoneItems() {
    const allTimezones = this.UserFactory.getLoggedUser().all_timezones;
    return this.AngularTimezoneService.buildTimezoneDropdownItems(allTimezones);
  }

  buildOptinTitleItems(optinCTS) {
    const metaTitle = this.$translate.instant('parameters/quick_replies/details/optin-cts-titles/meta-title');
    return optinCTS.map(optin => ({
      id: optin,
      label: `${optin.optin_label} (${metaTitle} ${optin.recurring_notification_title})`
    }));
  }

  buildRatingOperatorItems() {
    return [{
      id: '>',
      label: this.$translate.instant(
        'higher-than'
      )
    }, {
      id: '>=',
      label: this.$translate.instant(
        'higher-or-equal-to'
      )
    }, {
      id: '==',
      label: this.$translate.instant(
        'equal-to'
      )
    }, {
      id: '<=',
      label: this.$translate.instant(
        'lower-or-equal-than'
      )
    }, {
      id: '<',
      label: this.$translate.instant(
        'lower-than'
      )
    }];
  }

  static DropdownItemsFactory(StrategiesFactory, $translate, UserFactory, AngularTimezoneService, AngularAlcmeonContextService) {
    return new DropdownItemsService(StrategiesFactory, $translate, UserFactory, AngularTimezoneService, AngularAlcmeonContextService);
  }
}

DropdownItemsService.DropdownItemsFactory.$inject = ['StrategiesFactory', '$translate', 'UserFactory', 'AngularTimezoneService', 'AngularAlcmeonContextService'];


function _emptyItem(label) {
  const item = { 'subitems': [] };
  if (label) {
    item.label = label;
  }
  return item;
}
